module.exports = __webpack_public_path__ + "static/media/pg_logo.a85e8e1f.png";